import { Dialog, DialogContent, DialogHeader, DialogTitle } from "~/components/ui/dialog";
import Content from './Content';
import Text from "~/components/atoms/Text";

export default function TruCheckModal({ visible, setVisible, date }: { visible: boolean, setVisible: (open: boolean) => void }) {
  return (
    <div
      onClick={(e) => e.stopPropagation()}
      onPointerDown={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
    >
      <Dialog open={visible} onOpenChange={setVisible}>
        <DialogContent
          className="max-w-xl rounded-lg p-4"
          onClick={(e) => e.stopPropagation()}
          onPointerDown={(e) => e.stopPropagation()}
        >
          <DialogHeader>
            <DialogTitle className="text-lg font-semibold pb-2 border-b flex items-center gap-2">
              <img
                src={`${process.env.PUBLIC_REMIX_APP_ASSESTS_IMAGES}/assets/icons/tick.avif`}
                alt="tick_mark"
                className="object-cover"
                width={20}
                height={20}
              />
              <Text>Verified Price</Text>
            </DialogTitle>
            <Content date={date} />
          </DialogHeader>
        </DialogContent>
      </Dialog>
    </div>
  );
}